export default __webpack_public_path__ + "static/media/register_header.163b4bf1.svg";